import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MainLayOut from '../layout/admin';
import Dashboard from '../pages/Dashboard';
import ClientPage from '../pages/Client';
import VendorPage from '../pages/Vendor';
// import ClientForm from '../containers/Forms';
import VendorForm from '../containers/Forms/Vendor';
import ClientViewPage from '../pages/Client/view';
import Page404 from '../pages/404';
import Booking from '../pages/Booking';
import NewBooking from '../containers/Forms/Booking';
import Newtrip from '../containers/Forms/Trip';
import Trip from '../pages/Trip/Triplist';
import TripDetails from "../pages/Trip/details";
import Routess from '../pages/Trip/view/Routes';
import BookingView from '../pages/Booking/view/main';
import NoInternet from '../pages/NoInternet';
import Employee from '../pages/Employee/Employee';
import ManageEmployee from '../containers/Forms/Employee/Employee';
import ManageClient from '../containers/Forms/Client/index';
import useNetworkStatus from '../service/useNetworkStatus';
import Loading from '../components/Loading/Loading';
import Driver from '../pages/Driver/Driver';
import Vehicles from '../pages/Vehicle/vehicles';
import Managevehicle from '../containers/Forms/Vehicles/Managevehicle';
import Surveyor from '../pages/Surveyor/Surveyor';
import Managesurveyor from '../containers/Forms/Surveyor/ManageSurveyor';
import ManageDriver from '../containers/Forms/Driver/ManageDriver';
import RoutesScreen from '../pages/Routes/Routes';
import ManageRoutes from '../containers/Forms/Routes/ManageRoutes';
import RouteViewPage from '../pages/Routes/view';
import ManageBookingDraft from '../containers/Forms/BookingDraft/ManageBookingDraft';
import LivePinTracking from '../pages/Vehicle/LivePinTracking';
const PrivateRoutes = () => {
  const isAuthenticated = !!localStorage.getItem("motosop");
  const isOnline = useNetworkStatus();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!isAuthenticated) {
    return <Navigate replace to="/login" />;
  }



  if (isLoading) {
    return <Loading />
  }


  return (
    <Routes>
      <Route path="/" element={<MainLayOut />}>
        <Route index element={<Navigate replace to="/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="client" element={<ClientPage />} />
        <Route path="client/add" element={<ManageClient />} />
        <Route path="client/view/:id" element={<ClientViewPage />} />
        <Route path="client/edit/:id" element={<ManageClient />} />
        <Route path="vendor" element={<VendorPage />} />
        <Route path="vendor/add" element={<VendorForm />} />
        <Route path="vendor/edit/:id" element={<VendorForm />} />
        <Route path="booking" element={<Booking />} />
        <Route path="booking/view/:id" element={<BookingView />} />
        <Route path="booking/newbooking" element={<NewBooking />} />
        <Route path="booking/draft/:id" element={<ManageBookingDraft />} />
        <Route path="trip" element={<Trip />} />
        <Route path="trip/Newtrip" element={<Newtrip />} />
        <Route path="trip/:bookingID" element={<Newtrip />} />
        <Route path="trip/view/trip/:id" element={<TripDetails />} />
        <Route path="view/Routes" element={<Routes />} />
        <Route path="routes" element={<RoutesScreen />} />
        <Route path="routes/add" element={<ManageRoutes />} />
        <Route path="routes/edit/:id" element={<ManageRoutes />} />
        <Route path="routes/view/:id" element={<RouteViewPage />} />
        <Route path="employee" element={<Employee />} />
        <Route path="employee/add" element={<ManageEmployee />} />
        <Route path="employee/edit/:id" element={<ManageEmployee />} />
        <Route path="driver" element={<Driver />} />
        <Route path="Vehicles" element={<Vehicles />} />
        <Route path="vehicles/managevehicle" element={<Managevehicle />} />
        <Route path="vehicles/managevehicle/:id" element={<Managevehicle />} />
        <Route path="vehicles/livepin-tracking" element={<LivePinTracking />} />
        <Route path="surveyor" element={<Surveyor />} />
        <Route path="surveyor/managesurveyor" element={<Managesurveyor open={true} setOpen={() => { }} />} />
        <Route path="surveyor/managesurveyor/:id" element={<Managesurveyor open={true} setOpen={() => { }} />} />
        <Route path="driver/managedriver" element={<ManageDriver />} />
        <Route path="driver/managedriver/:id" element={<ManageDriver />} />
        <Route path="*" element={<Page404 />} />
      </Route>
    </Routes>
  );
};

export default PrivateRoutes;
